import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { increment, decrement } from "../../redux/cart/cartSlice";
import CheckBookingForm from "./CheckBookingForm";

function CartList({ active, setActive }) {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.items);

  const [activeCheckout, setActiveCheckout] = useState(false);

  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.qty,
    0
  );

  return (
    <>
   
      {active && !activeCheckout && (
        <>
          <div className="cart-overlay" onClick={() => setActive(false)} />

          <div className="cart-drawer open">
            <div className="cart-wrapper">
              <div className="cart-header">
                <h2>My Cart</h2>
                <button onClick={() => setActive(false)}>✕</button>
              </div>

              {cartItems.length === 0 && (
                <p className="empty-cart">Cart is empty</p>
              )}

              {cartItems.map((item) => (
                <div
                  className="cart-item"
                  key={`${item._id}-${item.note}`}
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/80")
                    }
                  />

                  <div className="cart-info">
                    <h4>{item.name}</h4>
                    <p className="note">Note: {item.note}</p>

                    <div className="qty-price">
                      <div className="qty-box">
                        <button
                          onClick={() =>
                            dispatch(
                              decrement({
                                _id: item._id,
                                note: item.note,
                              })
                            )
                          }
                        >
                          −
                        </button>

                        <span>{item.qty}</span>

                        <button
                          onClick={() =>
                            dispatch(
                              increment({
                                _id: item._id,
                                note: item.note,
                              })
                            )
                          }
                        >
                          +
                        </button>
                      </div>

                      <span className="price">
                        Rs. {item.price * item.qty}.00
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="subtotal">
                <span>SUBTOTAL</span>
                <span>Rs. {subtotal}.00</span>
              </div>

              <button
                className="checkout-btn"
                disabled={cartItems.length === 0}
                onClick={() => {
                  setActive(false);
                  setActiveCheckout(true);
                }}
              >
                BUY NOW
              </button>
            </div>
          </div>
        </>
      )}

      {activeCheckout && (
        <CheckBookingForm
          onBack={() => {
            setActiveCheckout(false);
            setActive(true);
          }}
          onClose={() => setActiveCheckout(false)}
        />
      )}


    </>
  );
}

export default CartList;
